import script from "./VideoDisplay.vue?vue&type=script&setup=true&lang=js"
export * from "./VideoDisplay.vue?vue&type=script&setup=true&lang=js"

import "./VideoDisplay.vue?vue&type=style&index=0&id=641e5b54&scoped=true&lang=css"
import "./VideoDisplay.vue?vue&type=style&index=1&id=641e5b54&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-641e5b54"]])

export default __exports__